import React from "react";

function Work() {
  return (
    <div className="pt-16 px-4 sm:px-6 lg:px-8 lg:pt-24">
      <h1 className="text-3xl font-bold tracking-tight text-white text-center sm:text-4xl">
        Experience Overview
      </h1>

      <ol className="mt-6 space-y-4 mx-auto max-w-3xl text-center">
        {/* button to download resume */}
        <div className="mt-4">
          <a
            href="/assets/Resume/Resume%2012_3%20(6).pdf"
            download
            className="inline-flex w-full items-center justify-center rounded-md border border-transparent outline-3 outline py-3 text-base font-medium text-white shadow-sm button_slide slide_right focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
          >
            Download Resume
          </a>
        </div>

        {/* Education */}
        {/* <li className="text-2xl text-white font-semibold mb-5">
          Education
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Purdue University</strong>
            <br />
            Major: Computer Engineering
            <br />
            Certificate: Semiconductors and Microelectronics
          </p>
        </li> */}

        {/* Work Experience */}
        {/* <li className="text-2xl text-white font-semibold mb-5">
          Work Experience
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>
              Marketing Coordinator & Assistant Journal Coordinator
            </strong>
            <br />
            Journal of Purdue Undergraduate Research (JPUR) — Develop and curate
            content across five channels, reaching over 1,000 students and
            faculty to foster community engagement and drive manuscript
            submissions.
          </p>
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Machine Learning Intern</strong>
            <br />
            Silicon Technologies Incorporated — Designed a multi-agent AI
            framework to automate the full analog IC design flow, resulting in a
            projected five-hour reduction in weekly design time per engineer.
            Analyzed the framework's technical and financial viability,
            evaluating deployment strategies, data scalability, and long-term
            competitive advantages.
          </p>
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Electrical Engineering Intern</strong>
            <br />
            Action Manufacturing Company — Assembled and validated a custom PCB
            for M107 warhead armament systems to ensure deployment reliability
            through functional testing, and developed a systematic inspection
            system for MK60 gear systems and proposed new quality control
            protocols.
          </p>
        </li> */}

        {/* Research Experience */}
        {/* <li className="text-2xl text-white font-semibold mb-5">
          Research Experience
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Undergraduate Researcher</strong>
            <br />
            Purdue University — Leverage multi-instrument datasets (including
            reflectance spectra, XRF elemental profiles, and microscopic images)
            to develop a binary classification model for counterfeit detection,
            optimized via Bayesian optimization.
          </p>
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Undergraduate Research Fellow</strong>
            <br />
            Purdue University — Conducted research under Dr. Peter Bermel to
            develop a novel testing framework that qualified commercial
            microelectronics, such as the FTLX8574D3BCV multimode 10G SFP+
            optical transceiver, for space. Simulated charged particle
            interactions using SRIM/TRIM software to design a shielding strategy
            with materials like tungsten and doped polymers, mitigating ionizing
            radiation effects and reducing secondary interactions.
          </p>
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Research Assistant</strong>
            <br />
            Abington Neurological Associates — Reviewed and documented
            prodromal, aura, and headache symptoms from 400+ patient records to
            identify early warning signs, contributing to a research paper on
            migraine prediction.
          </p>
        </li> */}

        {/* Extracurriculars */}
        {/* <li className="text-2xl text-white font-semibold mb-5">
          Extracurriculars
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Scalable Asymmetric Life Cycle Engagement (SCALE)</strong> —
            Curated a monthly newsletter by collaborating with professors
            nationwide to spotlight innovative research for SCALE, an immersive
            initiative developing a skilled microelectronics workforce for the
            Department of Defense.
          </p>
          <p className="text-lg leading-6 text-gray-400 mt-2">
            <strong>Scope Consulting</strong> — Built infrastructure to power an
            ETL pipeline aggregating over 500 Great Harvest Bread Company
            products for a machine-learning model using AWS Lambda, Amazon RDS,
            and Elastic Beanstalk. Consulted for Beta Agency to identify
            commercial real estate opportunities in Southern California via a
            Power BI interface that visualizes key storefront metrics.
          </p>
        </li> */}
      </ol>
    </div>
  );
}

export default Work;
